import { render, staticRenderFns } from "./NoteEdit.vue?vue&type=template&id=7b2c54c6&"
import script from "./NoteEdit.vue?vue&type=script&lang=js&"
export * from "./NoteEdit.vue?vue&type=script&lang=js&"
import style0 from "./NoteEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
